<template>
  <div :class="device.desktop ? `home pa-6 grey lighten-4`:`home pa-0 grey lighten-4`">

    <v-row class="pa-1">
      <v-spacer></v-spacer>
      <v-col :cols="device.desktop ? `12` : `12`">
        <v-card class="animated animate__bounceIn">
          <v-toolbar
            :color="theme.color"
            :dark="theme.mode"
            class=" animate__animated animate__fadeInDown"
            flat
          >
            <div class="rounded-pill white pb-1 pr-5 pt-1">
              <v-icon
                color="blue"
                class="ml-1  mr-1  "
              >mdi-circle</v-icon> <span class="blue--text">
                Profil UP2K
              </span>
            </div>
          </v-toolbar>

          <v-card-text>
            <v-row class="mt-1">
              <v-col :cols="device.desktop ? 10:12">
                <v-col cols="12">
                  <v-text-field
                    label="Nama Usaha UP2K"
                    placeholder=""
                    outlined
                    dense
                    hide-details
                    :color="theme.color"
                    v-model="record.name"
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-textarea
                    label="Deskripsi Singkat Perusahaan"
                    placeholder="Silahakan berikan gamabaran singkat tentang perusahaan anda"
                    outlined
                    dense
                    hide-details
                    :color="theme.color"
                    v-model="record.description"
                    rows="4"
                  ></v-textarea>
                </v-col>
                <v-col cols="12">
                  <v-select
                    label="Kriteria"
                    outlined
                    dense
                    hide-details
                    v-model="record.criteria_uuid"
                    :color="theme.color"
                    :items="criterias"
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <v-select
                    label="Bidang Usaha"
                    outlined
                    dense
                    hide-details
                    v-model="record.type_uuid"
                    :color="theme.color"
                    :items="kinds"
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="Tahun Berdiri"
                    placeholder=""
                    outlined
                    dense
                    hide-details
                    :color="theme.color"
                    v-model="record.tahun_berdiri"
                    type="number"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="Produk Utama"
                    placeholder=""
                    outlined
                    dense
                    hide-details
                    :color="theme.color"
                    v-model="record.produk_utama"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="Jumlah Permodalan"
                    placeholder=""
                    outlined
                    dense
                    hide-details
                    :color="theme.color"
                    v-model="record.modal"
                    type="number"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="Jumlah Omzet Per Tahun"
                    placeholder=""
                    outlined
                    dense
                    hide-details
                    :color="theme.color"
                    v-model="record.omzet"
                    type="number"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="Jumlah Karyawan"
                    placeholder=""
                    outlined
                    dense
                    hide-details
                    :color="theme.color"
                    v-model="record.jumlah_karyawan"
                    type="number"
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    label="Nama Pemilik | Kontak Yang Bisa Dihubungi"
                    placeholder=""
                    outlined
                    dense
                    hide-details
                    :color="theme.color"
                    v-model="record.owner"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="Nomor Induk Kependudukan (NIK)"
                    placeholder=""
                    outlined
                    dense
                    hide-details
                    :color="theme.color"
                    v-model="record.nik"
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    label="Nomor Telepon (Whatsapp)"
                    placeholder="081xxx "
                    outlined
                    dense
                    hide-details
                    :color="theme.color"
                    v-model="record.phone"
                    type="number"
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    label="Website"
                    placeholder=""
                    outlined
                    dense
                    hide-details
                    :color="theme.color"
                    v-model="record.website"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="Facebook"
                    placeholder=""
                    outlined
                    dense
                    hide-details
                    :color="theme.color"
                    v-model="record.facebook"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="Instagram"
                    placeholder=""
                    outlined
                    dense
                    hide-details
                    :color="theme.color"
                    v-model="record.instagram"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    label="Twitter"
                    placeholder=""
                    outlined
                    dense
                    hide-details
                    :color="theme.color"
                    v-model="record.twitter"
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-select
                    label="Kabupaten / Kota"
                    outlined
                    dense
                    hide-details
                    v-model="record.regency_code"
                    :color="theme.color"
                    :items="regencies"
                    @change="fetchDistrict"
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    label="Kecamatan"
                    outlined
                    dense
                    hide-details
                    :color="theme.color"
                    v-model="record.district_code"
                    :items="districts"
                    @change="fetchVillages"
                  >

                  </v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    label="Desa / Kelurahan"
                    outlined
                    dense
                    hide-details
                    :color="theme.color"
                    v-model="record.village_code"
                    :items="villages"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    label="Alamat"
                    placeholder=""
                    outlined
                    dense
                    hide-details
                    :color="theme.color"
                    v-model="record.address"
                    rows="2"
                  ></v-textarea>
                </v-col>
                <v-col cols=12>
                  <v-row>
                    <v-col :cols="device.desktop ?6:12">
                      <v-img
                        height="100%"
                        width="100%"
                      >

                        <l-map
                          style="height: 300px;width: 100%;z-index:9999; "
                          :zoom="zoom"
                          :center="center"
                          @update:center="centerUpdated"
                        >
                          <v-geosearch
                            :options="geosearchOptions"
                            style="width:100px; border: 1px;"
                          ></v-geosearch>
                          <l-tile-layer
                            :url="url"
                            :attribution="attribution"
                          ></l-tile-layer>
                          <l-marker
                            :key="marker.id"
                            :visible="marker.visible"
                            :draggable="marker.draggable"
                            :lat-lng.sync="marker.position"
                          >

                            <l-icon
                              iconSize=32
                              icon-url="/images/icon-marker-merah.png"
                            />
                            <l-popup :content="marker.tooltip" />
                            <l-tooltip :content="marker.tooltip" />
                          </l-marker>
                        </l-map>
                      </v-img>
                    </v-col>
                    <v-col :cols="device.desktop ?6:12">

                      <v-col cols=12>
                        <v-text-field
                          class="font-weight-thin"
                          placeholder=""
                          label="Garis Bujur"
                          outlined
                          dense
                          hide-details
                          :color="theme.color"
                          v-model="record.lat"
                          :filled="record.lat"
                        ></v-text-field>
                      </v-col>
                      <v-col cols=12>
                        <v-text-field
                          class="font-weight-thin"
                          placeholder=""
                          label="Gari Lintang"
                          outlined
                          dense
                          hide-details
                          :color="theme.color"
                          v-model="record.lng"
                          :filled="record.lng"
                        ></v-text-field>
                      </v-col>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <v-row class="mx-1 px-5  py-2 grey--text grey lighten-3">
                    <div>Unggah Foto Tempat Usaha</div>
                    <v-spacer></v-spacer>
                    <div>
                      <v-tooltip
                        :color="theme.color"
                        bottom
                      >
                        <template v-slot:activator="{ on }">
                          <v-btn
                            text
                            small
                            icon
                            v-on="on"
                            color="white"
                            class="animate__animated animate__heartBeat animate__delay-1s"
                            @click="uploadFoto"
                          >
                            <v-icon color="grey">mdi-plus-circle</v-icon>
                          </v-btn>
                        </template>
                        <span>Unggah Foto Toko</span>
                      </v-tooltip>
                    </div>
                  </v-row>
                </v-col>

                <v-card-text>
                  <v-row>
                    <v-col
                      :cols="device.desktop ? 3: 12"
                      v-for="(item, index) in images"
                      :key="index"
                    >
                      <v-card class="flat outlined text-center pa-2">

                        <img
                          :src="item.path"
                          alt="Gambar Produk"
                          srcset=""
                          width="200"
                          height="200"
                        >
                        <v-card-actions>
                          <v-btn
                            block
                            outlined
                            small
                            :color="theme.color"
                            @click="deleteFoto(index)"
                          >Hapus</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
              <v-col :cols="device.desktop ? 2:12">
                <v-col cols="12">
                  <v-row class="justify-center">
                    <v-avatar size="150">
                      <v-img
                        :class="[theme.color + ' lighten-2 with-backdrop']"
                        :aspect-ratio="3 / 4"
                        :src="foto"
                        :lazy-src="foto"
                      >
                        <div
                          class="
                          d-flex
                          flex-column
                          align-center
                          justify-center
                          user-select-none
                        "
                          style="height: 100%"
                        >
                          <div class="pl-14">
                            <v-btn
                              icon
                              dark
                              @click="uploadLogo"
                            >
                              <v-icon>photo_camera</v-icon>
                            </v-btn>
                          </div>
                        </div>
                      </v-img>

                    </v-avatar>
                    <div class="text-center">
                      Logo (max: 2Mb)
                    </div>
                  </v-row>
                </v-col>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions class="mt-5">

            <v-col class="text-right">
              <v-btn
                outlined
                :color="theme.color"
                @click="postUpdate"
                rounded
              >SIMPAN</v-btn>
            </v-col>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
  </div>
</template>
  
  <script>
import { mapActions, mapState } from "vuex";
import {
  LMap,
  LTileLayer,
  LMarker,
  LIcon,
  LPopup,
  LTooltip,
} from "vue2-leaflet";
import { OpenStreetMapProvider } from "leaflet-geosearch";
import VGeosearch from "vue2-leaflet-geosearch";
import "leaflet/dist/leaflet.css";

export default {
  name: "profil-pengguna",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    VGeosearch,
    LIcon,
    LPopup,
    LTooltip,
  },
  data: () => ({
    record: {},
    foto: "/",
    criterias: [],
    kinds: [],
    regencies: [],
    districts: [],
    villages: [],
    images: [],
    //map property
    url: "https://tile.openstreetmap.org/{z}/{x}/{y}.png",
    attribution:
      '&copy; <a  class="green--text" target="_blank" href="#">Pemprov Banten</a>',
    zoom: 13,
    //-6.1716001, 106.6405384
    center: [-6.1716001, 106.6405384],

    geosearchOptions: {
      // Important part Here
      provider: new OpenStreetMapProvider(),
    },
    marker: {
      id: "m1",
      position: { lat: -6.1716001, lng: 106.6405384 },
      tooltip: "Pilih lokasi usaha UP2K anda",
      draggable: true,
      visible: true,
    },
  }),
  computed: {
    ...mapState([
      "theme",
      "http",
      "device",
      "records",
      "loading",
      "event",
      "snackbar",
    ]),
  },
  created() {
    this.setPage({
      crud: true,
      dataUrl: "api/",
      title: "PROFIL UP2K PKK",
      subtitle: "Manajemen Profil UP2K",
      breadcrumbs: [
        {
          text: "Manajemen",
          disabled: true,
          href: "",
        },
        {
          text: "Profil UP2K PKK",
          disabled: true,
          href: "",
        },
      ],
      add: false,
      edit: false,
      actions: {
        refresh: true,
        add: true,
        edit: true,
        delete: true,
      },
      showtable: false,
    });

    this.getUserPosition();
    this.fetchCriterias();
    this.fetchKinds();
    this.fetchRegencies();
    this.fetchRecord();
  },
  mounted() {},
  methods: {
    ...mapActions([
      "setPage",
      "assignFileBrowse",
      "getUserInfo",
      "initUploadLibrary",
      "setRecord",
      "catchError",
      "setLoading",
      "getUserInfo",
    ]),
    fetchRecord: async function () {
      let { data } = await this.http.get("api/v2/umkm/company");

      this.record = data ? data : {};

      this.foto = data.logo_path;
      this.images = data.images;
      this.marker.position.lat = data.lat;
      this.marker.position.lng = data.lng;
    },
    postUpdate: async function () {
      try {
        this.record.images = this.images;
        this.setLoading({ dialog: true, text: "Proses simpan data profil" });
        let {
          data: { code, success, message },
        } = await this.http.post("api/v2/umkm/company", this.record);

        if (!success) {
          this.snackbar.color = "red";
          this.snackbar.text = message;
          this.snackbar.state = true;
          return;
        }

        this.snackbar.color = this.theme.color;
        this.snackbar.text = message;
        this.snackbar.state = true;

        this.fetchRecord();
        this.getUserInfo();
      } catch (error) {
        this.catchError(error);
      } finally {
        this.setLoading({ dialog: false, text: "" });
      }
    },

    uploadFoto: function () {
      this.assignFileBrowse({
        fileType: [".jpg", ".jpeg", ".png"],
        query: {
          doctype: "apps",
        },
        callback: (response) => {
          setTimeout(() => {
            this.images.push({ path: response.path, name: response.name });
          }, 1000);
        },
      });
    },

    uploadLogo: function () {
      this.assignFileBrowse({
        fileType: [".jpg", ".jpeg", ".png"],
        query: {
          doctype: "apps",
        },
        callback: (response) => {
          setTimeout(() => {
            this.foto = response.path;
            this.record.logo = response.name;
          }, 1000);
        },
      });
    },

    deleteFoto: function (val) {
      this.images.splice(val, 1);
    },

    //custome function
    fetchCriterias: async function () {
      try {
        let { data } = await this.http.get("api/v2/combo/criteria");
        this.criterias = data;
      } catch (error) {}
    },
    fetchKinds: async function () {
      try {
        let { data } = await this.http.get("api/v2/combo/kind");
        this.kinds = data;
      } catch (error) {}
    },
    fetchRegencies: async function () {
      try {
        let { data } = await this.http.get("api/v2/combo/regency");
        this.regencies = data;
      } catch (error) {}
    },
    fetchDistrict: async function () {
      try {
        let { data } = await this.http.get(
          "api/v2/combo/district/" + this.record.regency_code
        );
        this.districts = data;
      } catch (error) {}
    },
    fetchVillages: async function () {
      try {
        let { data } = await this.http.get(
          "api/v2/combo/village/" + this.record.district_code
        );
        this.villages = data;
      } catch (error) {}
    },
    centerUpdated(center) {
      this.center = center;
    },
    getUserPosition: async function () {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((pos) => {
          this.center = { lat: pos.coords.latitude, lng: pos.coords.longitude };
          this.center = [pos.coords.latitude, pos.coords.longitude];
          this.marker.position = {
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
          };
        });
      }
    },
  },
  watch: {
    "record.regency_code": {
      handler() {
        this.fetchDistrict();
      },
    },
    "record.district_code": {
      handler() {
        this.fetchVillages();
      },
    },
    "marker.position": {
      handler() {
        this.record.lat = this.marker.position.lat;
        this.record.lng = this.marker.position.lng;
      },
      deep: true,
    },
  },
};
</script>
  
<style></style>
  